/**
 * https://artof.pro © 2020
 * Supports ES6 syntax
 **/

import $ from 'jquery';

import './_global';
// import './_analytics.js';
import './_carousels.js';
import './_product.js';
import { loadCaptcha } from './_recaptcha';

$(document).ready(function () {

  $("[data-suggest-url]").each(function () {
    let url = $(this).data('suggest-url');
    let output = $(this).find('.suggest-output');

    if (output.length < 1) return;

    let timeout = false;
    let input = $(this).find('[name=q]');
    let lastval = input.val();

    input
      .on('keyup change', function () {
        let query = $(this).val();
        if (query == lastval) return;
        lastval = query;
        if (query.length > 2) {
          if (timeout) clearTimeout(timeout);
          timeout = setTimeout(function () {
            $.get(url, { q: query }, function (ret) {
              output.html(ret);
            });
            timeout = false;
          }, 500);
        }
      })
      .on('blur', function () {
        setTimeout(function () {
          output.html('');
        }, 100);
      });
  });


  // Mobile menu toggler

  $('#navToggler').on('click', function () {
    $(this).parents('.white').toggleClass('opened');
  });

  $('.nav-layered > .btn-primary').on('click', function () {
    $(this).toggleClass('active');
  });


  // left navigation toggles

  $('.nav-catalog > ul > li > a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  $('.nav-catalog > .title').on('click', function (e) {
    if (window.innerWidth > 991) {
      e.preventDefault();
    } else {
      $(this).toggleClass('active');
    }
  });


  // Modal

  $('[data-toggle="modal"]').on('click', function () {
    var target = $(this).data('target');
    $(target).removeClass('d-none');
  });

  $('.modal .close').on('click', function () {
    $(this).parents('.modal').addClass('d-none');
  });

  $('.modal').on('click', function (event) {
    if (!$(event.target).parents('.modal-content').length) {
      $(this).addClass('d-none');
    }
  });


  // Feedback

  $('#contactForm2').submit(function (e) {
    e.preventDefault();

    $('#contactForm2-success').hide();

    if ($('#contactForm2 .validation-failed').length > 0) return;

    let form = $(this);
    form.find('[type="submit"]').toggleSpinner();

    loadCaptcha(form).then(function () {

      $.post(form.attr('action'), form.serialize(), function (ret) {
        if (ret === 'success') {
          $('#contactForm2-success').show();
          form[0].reset();
        } else {
          alert(ret);
        }

        form.find('[type="submit"]').toggleSpinner(false);
      });
    }, function (error) {
      console.log(error);
      form.find('[type="submit"]').toggleSpinner(false);
    });
  });


  // Ask a question form

  $('#contactForm').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);

    form.find('[type=submit]').toggleSpinner();

    loadCaptcha(form).then(function() {
      new Promise(function(resolve, reject) {
        $.ajax({
          url: form.attr('action'),
          type: 'POST',
          data: form.serialize(),
          success: function (resp) {
            if (resp == 'success')
              resolve();
            else
              reject(resp);
          },
          statusCode: {
            500: function (resp) {
              reject(resp.responseText);
            }
          },
        });

      }).then(function () {
        $('#feedback').addClass('d-none');
        $('#feedback-success').removeClass('d-none');
      }, function (err) {
        form.prepend(`<div class="alert alert-danger">${err}</div>`);
        form.find('[type=submit]').toggleSpinner(false);
      });
    }, function (error) {
      console.log(error);
      form.find('[type="submit"]').toggleSpinner(false);
    });
  });


  // Other forms submit with captcha checker

  $('.check-captcha').on('submit', function (e) {
    e.preventDefault();
    const form = $(this);

    form.find('[type="submit"]').toggleSpinner();

    loadCaptcha(form)
      .then(function () {
        form.off('submit').submit();
      }, function (error) {
        console.log(error);
        form.find('[type="submit"]').toggleSpinner(false);
      });
  });
});
